<template>
  <div class="manageCertificate">
    <div class="">
      <el-select v-model="value" placeholder="请选择" @change="((val)=>{changeStatus(val)})">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.projectName"
          :value="item.id"
          >
        </el-option>
      </el-select>
    </div>
    <el-table
      :data="tableData"
      v-loading="tableLoading" element-loading-text="加载中"
      style="width: 100%">
      <el-table-column
        label="证书名称"
        prop="projectName">
      </el-table-column>
      <el-table-column
        label="项目名称"
        prop="typeName">
      </el-table-column>
      <el-table-column
        label="证书号未使用个数"
        prop="leftValidNum">
      </el-table-column>
      <el-table-column
        label="已购买数量"
        prop="total">
      </el-table-column>
      <el-table-column
        align="center"
        label="操作"
        >

        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="buyCertificateNumber(scope.$index, scope.row)">购买证书号</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="购买证书号" :center="true" :visible.sync="dialogFormVisible" :destroy-on-close="true" width="30%" v-loading="trueLoading" element-loading-text="加载中">
      <!-- <el-divider><span>证书号50元/个</span></el-divider> -->
      <el-form>
        <el-form-item label="证书名称" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入内容"
            v-model="certName"
            :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="所属项目" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入内容"
            v-model="certPro"
            :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="购买数量" :label-width="formLabelWidth">
          <el-input-number v-model="certNum" controls-position="right" @change="handleChange" :min="1" :max="999"></el-input-number>
          <!-- <el-input
            placeholder="请输入需要购买的数量"
            v-model="certNum"
            :disabled="false"
            @input="input()">
          </el-input> -->
        </el-form-item>
        <!-- <el-form-item label="所需金额" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入内容"
            v-model="tatolMoney"
            :disabled="true">
          </el-input>
        </el-form-item> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createBuyOrderFun()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="扫码支付" :center="true" :visible.sync="showPayCode" width="20%" :destroy-on-close="true" @close="handleClose()"  v-loading="loading" element-loading-text="加载中" >
      <p style="text-align:center;height:20px;margin:5px 0">
        <img src="static/images/wx_pay.png" style="width:18px; height:18px;"/>
        <span style="text-align:center;margin-left:5px;">微信扫描下方二维码，完成支付</span>
      </p >
      <div style="width:100%;height:120px;text-align:center;margin-top:20px;">
        <div id="qrcode" ref="qrCodeDiv" style="width:120px;height:120px;margin:0px auto;"></div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createBuyOrderFun()">确 定</el-button>
      </div> -->
    </el-dialog>
    <div class="page-warp">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { queryAllProject, certificatePageQuery, createBuyOrder, queryOrderStatus } from '@/api/association'
import UserHeaderNav from '@/components/common/UserCenter/UserHeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import {formatDate} from '@/components/common/config/formatTime.js'
import md5 from 'js-md5'
import QRCode from 'qrcodejs2'
export default {
  name: '',
  components: {
    UserHeaderNav,
    CopyRight,
    md5,
    QRCode
  },
  data () {
    return {
      current: null,
      loading: false,
      trueLoading: false,
      total: null,
      type: this.$route.params.type,
      currentPage: 1,
      assoUserInfo: JSON.parse(localStorage.getItem('assoUserInfo')),
      titleMsg: '个人信息',
      options: [],
      value: '',
      tableData: [],
      search: '',
      pageNo: 1,
      pageSize: 8,
      dialogFormVisible: false,
      showPayCode: false,
      formLabelWidth: '120px',
      certName: '',
      certPro: '',
      certNum: 0,
      tatolMoney: '',
      certId: null,
      timer: null,
      tableLoading: false
    }
  },
  methods: {
    formatDate,

    // 查询协会下所有项目
    getQueryAllProject () {
      queryAllProject({ assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          this.options = res.data.data
          console.log(res.data)
        }
      })
    },
    certificatePageQuery () {
      this.tableLoading = true
      certificatePageQuery({ pageNo: this.pageNo, pageSize: this.pageSize, projectId: this.value === '' ? -1 : this.value, memberId: this.assoUserInfo.memberId }).then(res => {
        this.tableLoading = false
        if (res.data.status === 0) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          console.log(res.data.data.list)
        } else {
          this.$message.warning(res.data.msg)
        }
      }).catch(() => {
        this.tableLoading = false
        this.$message.error('网络错误')
      })
    },
    handleCurrentChange: function (val) {
      this.certificatePageQuery()
    },
    // 获取证书列表
    changeStatus (e) {
      // this.value = selVal
      console.log(this.value)
      this.certificatePageQuery()
    },

    // 购买证书号
    buyCertificateNumber (index, row) {
      console.log(index, row)
      this.dialogFormVisible = true
      this.certName = row.projectName
      this.certPro = row.typeName
      this.certId = row.typeId
      this.tatolMoney = '￥' + this.certNum * 50
    },
    createBuyOrderFun () {
      this.trueLoading = true
      createBuyOrder({ assoId: localStorage.getItem('assoId'), certId: this.certId, memberId: this.assoUserInfo.memberId, num: this.certNum }).then(res => {
        this.trueLoading = false
        if (res.data.status === 0) {
          console.log(res.data.data)

          this.showPayCode = true
          this.dialogFormVisible = false
          this.paySure(res.data.data.amcnOrder.orderNo)
          this.$nextTick(() => {
            this.bindQRCode(res.data.data.payUrl)
          })
        } else {
          // this.loading = false
          this.$message.warning(res.data.msg)
        }
      }).catch(() => {
        this.trueLoading = false
        // clearInterval(this.timer)
        this.$message.warning('创建订单失败！')
      })
    },
    // 支付
    paySure (orderNo) {
      this.loading = true
      this.timer = setInterval(() => {
        queryOrderStatus(orderNo).then(res => {
          this.loading = false
          if (res.data.status === 0) {
            if (res.data.data === 1) {
              clearInterval(this.timer)
              this.$message.success('支付成功')
              this.showPayCode = false
              this.dialogFormVisible = false
              this.certificatePageQuery()
            }
          }
        }).catch(() => {
          this.loading = false
          clearInterval(this.timer)
          this.$message.warning('支付失败，请重新支付！')
        })
      }, 1000)
    },
    bindQRCode: function (str) {
      // eslint-disable-next-line no-new
      this.qrcode = new QRCode(this.$refs.qrCodeDiv, {
        text: str,
        width: 120,
        height: 120,
        colorDark: '#333333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L// 容错率，L/M/H
      })
    },
    handleClose (done) {
      this.showPayCode = false
      this.dialogFormVisible = false
      clearInterval(this.timer)
    },
    handleChange () {
      // this.tatolMoney = '￥' + this.certNum * 50
    },
    input () {
      // let val = this.certNum.replace(/[^0-9-]+/, '')
      let reg = / ".*[a-zA-z].*"/
      if (reg.test(this.certNum)) {
        this.$message.warning('请输入数字')
        return
      }
      this.certNum = this.certNum.replace(/[^\w]/g, '')
      // 防止输入01
      if (this.certNum.indexOf('.') < 0 && this.certNum !== '') {
        this.certNum = parseInt(this.certNum)
      }

      this.tatolMoney = '￥' + this.certNum * 50
    },
    handleDelete (index, row) {
      console.log(index, row)
    }
  },
  mounted () { // 这里必须是mouted钩子
    // 下拉加载更多监听滚轮
    // window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮 滚动事件
  },
  created () {
    // this.getQueryAssoDesc()
    this.getQueryAllProject()
    this.certificatePageQuery()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .manageCertificate{
    width: 100%;
    padding: 20px 0px;
  }
  .page-warp{
    position: absolute;
    bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/UserCenter/manageCertificate.vue